// extracted by mini-css-extract-plugin
module.exports = {"loading":"styles-module__loading___X6nq4","small":"styles-module__small___2RXRE"};